import React from 'react';

const DownloadDocument: React.FC<{ width?: string; height?: string; fill?: string }> = ({
  width = '24px',
  height = '24px',
  fill = '#000',
}): React.ReactElement => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4 0H19H21H21.0041L28 7.15485V32H4V0ZM6 2H19V9H26V30H6V2ZM21 2.85709L25.0506 7H21V2.85709ZM21 15H8V17H21V15ZM8 19.5H24V21.5H8V19.5ZM16 24H8V26H16V24Z"
          fill={fill}
        />
      </svg>
    </>
  );
};

export default DownloadDocument;
